<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<h1 class="ct2" id="p0024-01-0">
<a id="page24">
<b>103</b>
</a></h1><a id="page24">
<h2 class="ct1">Think big thoughts, but relish small pleasures.</h2>
</a></section><a id="page24">
</a></div>
<a id="page24">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter9.vue?b1d3f7e0